import { combineReducers } from "redux";
import { pendingTasksReducer as pendingTasks } from "react-redux-spinner";
import { routerReducer as routing } from "react-router-redux";

import { feedbackReduser as feedback } from "../feedback";
import { userReducer as user } from "../user";
import { adminReducer as admin } from "../admin";

const rootReducer = combineReducers({
  routing,
  user,
  pendingTasks,
  feedback,
  admin
});

export default rootReducer;
